
import { faInfo } from '@fortawesome/pro-regular-svg-icons'
import { Flex, TextInput } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { CollapsibleCard, InputPhoneNumber } from '@flecto/ui'

import { useFormContext } from './FormProfileAccount'
import styles from './styles.module.css'

export function CardBasicInfo() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_account' })

  const form = useFormContext()

  return (
    <CollapsibleCard opened>
      <CollapsibleCard.Icon icon={faInfo} withCircleBackground />
      <CollapsibleCard.Title>{t('card_user_info.title')}</CollapsibleCard.Title>
      <CollapsibleCard.Description>
        {t('card_user_info.description')}
      </CollapsibleCard.Description>
      <CollapsibleCard.Content>
        <Flex
          align='center'
          justify='space-between'
          gap='lg'
          mt='sm'
          className={styles.inputs}
        >
          <TextInput
            label={t('card_user_info.label_name')}
            w='100%'
            withAsterisk
            {...form.getInputProps('full_name')}
          />
          <InputPhoneNumber
            withAsterisk
            w='100%'
            label={t('card_user_info.label_phone_number')}
            valueDialCode={
              form.values.meta?.phone_number_country_code ?? '+351'
            }
            value={form.values.phone_number ?? ''}
            onChange={(event) => {
              form.setFieldValue('phone_number', String(event.target.value))
            }}
            onChangeDialCode={(code) => {
              form.setFieldValue('meta.phone_number_country_code', code)
            }}
            error={form.errors.phone_number}
          />
        </Flex>
      </CollapsibleCard.Content>
    </CollapsibleCard>
  )
}
